import request from '../utils/request';
import { stringify } from 'qs';


/**
 * 获取分组列表
 * @returns {Promise<void>}
 */
export async function getGroupList (params: object) {
    return request(`/api/user/group/list?${stringify(params)}`, {
        method: 'GET',
        requestType: 'form',
        data: params
    })
}

/**
 * 获取组内设备列表
 * @param params
 * @returns {Promise<R>}
 */
export async function getDeviceList (params: object) {
    return request(`/api/user/group/device/list?${stringify(params)}`, {
        method: 'GET',
        requestType: 'form',
        data: params
    })
}

/**
 * 批量截图
 * @param params
 */
export async function deviceScreencap (params: object) {
  return request(`/api/saas/device/screencap?${stringify(params)}`, {
    method: 'GET',
    requestType: 'form',
    data: params
  })
}

/**
 * 移动分组
 * @param params
 */
export async function deviceMove (params: object) {
  return request(`/api/user/group/move`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}

/**
 * 恢复出厂
 * @param params
 */
export async function deviceRecycle (params: object) {
  return request(`/api/saas/device/recycle`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}


/**
 * 重启云手机
 * @param params
 */
export async function deviceReboot (params: object) {
  return request(`/api/saas/device/reboot`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}


/**
 * 恢复出厂设置
 * @param params
 */
export async function deviceReset (params: object) {
  return request(`/api/saas/device/reset`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}

/**
 * 获取组内游戏列表
 * @param params
 */
export async function getGroupAppList (params: object) {
  return request(`/api/saas/device/app/game_list`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}

/**
 * 获取组内已安装和未安装app列表
 * @param params
 */
export async function getGroupAppInstallUninstallList (params: object) {
  return request(`/api/saas/device/app/group/install_uninstall_list`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}

/**
 * 组内安装、卸载
 * @param params
 * @constructor
 */
export async function appInstallUninstall (params: object) {
  return request(`/api/saas/device/app/group/install`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}

/**
 * 批量处理的启动、停止应用的获取游戏列表
 * @param params
 */
export async function getGroupAppRunStopList (params: object) {
  return request(`/api/saas/device/app/group/game_run_info_list`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}

/**
 * 运行app
 * @param params
 */
export async function appRun (params: object) {
  return request(`/api/saas/device/app/launch`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}

/**
 * 停止app
 * @param params
 */
export async function appStop (params: object) {
  return request(`/api/saas/device/app/stop`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}

/**
 * 一键新机
 * @param params
 */
export async function deviceVasNew (params: object) {
  return request(`/api/saas/device/new/phone`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}

/**
 * ip代理开启
 * @param params
 */
export async function deviceVasIPOpen (params: object) {
  return request(`/api/saas/device/ip/open`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}


/**
 * ip代理切换
 * @param params
 */
export async function deviceVasIPChange (params: object) {
  return request(`/api/saas/device/ip/change`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}

/**
 * ip代理关闭
 * @param params
 */
export async function deviceVasIPClose (params: object) {
  return request(`/api/saas/device/ip/close`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}

/**
 * 新建分组
 * @param params
 */
export async function groupAdd (params: object) {
  return request(`/api/user/group/add`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}

/**
 * 删除分组
 * @param params
 */
export async function groupDelete (params: object) {
  return request(`/api/user/group/delete?${stringify(params)}`, {
    method: 'DELETE',
    requestType: 'form',
    data: params,
  })
}

/**
 * 分组重命名
 * @param params
 */
export async function groupRename (params: object) {
  return request(`/api/user/group/rename`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}


/**
 * 设备故障修复
 * @param params
 */
export async function deviceRepair (params: object) {
  return request(`/api/saas/device/repair`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}

/**
 * 获取全局和组内统计数据
 * @param params
 */
export async function getDeviceInfo (params: object) {
  return request(`/api/user/room/group/stat?${stringify(params)}`, {
    method: 'GET',
    requestType: 'form',
    data: params,
  })
}

/**
 * 设备重命名
 * @param params
 */
export async function deviceRename (params: object) {
  return request(`/api/user/group/device/rename`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}

/**
 * 获取云机同步token
 */
export async function getDeviceToken (params: object) {
    return request(`/api/saas/device/play?${stringify(params)}`, {
        method: 'GET',
        requestType: 'form',
        data: params
    })
}



